import { render, staticRenderFns } from "./CGasTransport.vue?vue&type=template&id=ec8b6498"
import script from "./CGasTransport.vue?vue&type=script&lang=js"
export * from "./CGasTransport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports